import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const MasterIncentiveListRBAC = {
  pageID: 'f42199d864ff31b639a9491663e8c7a2',
  elementID: {
    BtnAddIncentive: 'f7d9ffbc643fc3bc728038b972a51a5a',
    BtnEditIncentive: 'a26747515546e48ef7950af2e0aac555',
  },
}
export const useRBACMasterIncentiveList = createUseRBAC(MasterIncentiveListRBAC.elementID)
export type UseRBACMasterIncentiveListType = ReturnType<typeof useRBACMasterIncentiveList>

export const MasterIncentiveAddRBAC = {
  pageID: 'fb5c008907d75cce30f1e8a9ecbf6023',
  elementID: {},
}
export const useRBACMasterIncentiveAdd = createUseRBAC(MasterIncentiveAddRBAC.elementID)
export type UseRBACMasterIncentiveAddType = ReturnType<typeof useRBACMasterIncentiveAdd>

export const MasterIncentiveEditRBAC = {
  pageID: 'f421783c4fff31b639a9491655c0dbea',
  elementID: {},
}
export const useRBACMasterIncentiveEdit = createUseRBAC(MasterIncentiveEditRBAC.elementID)
export type UseRBACMasterIncentiveEditType = ReturnType<typeof useRBACMasterIncentiveEdit>

export const MasterIncentiveDetailRBAC = {
  pageID: '70536f648cab2f135fa97063cada9549',
  elementID: {
    BtnEditIncentive: '48cb8272797b3a307c3e8d3e2f6e4ea6',
  },
}
export const useRBACMasterIncentiveDetail = createUseRBAC(MasterIncentiveDetailRBAC.elementID)
export type UseRBACMasterIncentiveDetailType = ReturnType<typeof useRBACMasterIncentiveDetail>
